"use client";

import { useEffect } from "react";

import { trackCatalogEvent } from "@/components/catalog/analytics";

export interface CatalogPageAnalyticsProps {
  readonly eventName:
    | "catalog_view_home"
    | "catalog_search"
    | "catalog_search_no_results"
    | "category_view"
    | "product_view";
  readonly productId?: string;
  readonly query?: string;
  readonly sku?: string;
  readonly payload?: Record<string, unknown>;
}

export function CatalogPageAnalytics({
  eventName,
  payload,
  productId,
  query,
  sku,
}: Readonly<CatalogPageAnalyticsProps>) {
  useEffect(() => {
    trackCatalogEvent({ eventName, payload, productId, query, sku });
  }, [eventName, payload, productId, query, sku]);

  return null;
}
